import createReducer, { RESET_STORE } from "../createReducer";
import { getToken } from "./user";

// Action Types
export const SET_CHATBOT_FILES = "ai.SET_CHATBOT_FILES";
export const SET_CHAT_MESSAGES = "ai.SET_CHAT_MESSAGES"; // Changed from ADD_MESSAGES
export const CLEAR_CHAT_MESSAGES = "ai.CLEAR_CHAT_MESSAGES";
export const SET_LOADING_MESSAGES = "ai.SET_LOADING_MESSAGES";

// Action Creators
export const setChatbotFiles =
  (obj) =>
  (dispatch, getState, { fetch }) => {
    //    if (!user ) return;
    const { token } = dispatch(getToken());
    const { user } = getState().user;
    const { apiUrl } = getState().global;
    const payload = { email: user.email };
    const url = `${apiUrl}/ai/pineconelistfiles/`;

    return fetch(url, {
      method: "POST",
      token,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: payload,
      success: (res) => {
        dispatch({ type: SET_CHATBOT_FILES, chatbotfiles: res.response });
      },
      failure: (err) => {
        // Handle error
      },
    });
  };

export const clearMessages =
  () =>
  (dispatch, getState, { fetch }) => {
    const { token } = dispatch(getToken());
    const { user } = getState().user;
    const { apiUrl } = getState().global;
    const url = `${apiUrl}/ai/pineconeclearmessages/`;

    return fetch(url, {
      method: "DELETE",
      token,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: { email: user.email },
      success: () => {
        dispatch({ type: CLEAR_CHAT_MESSAGES });
      },
      failure: () => {
        dispatch({ type: CLEAR_CHAT_MESSAGES });
      },
    });
  };

// Simplified action creators
export const setMessages = (messages) => ({
  type: SET_CHAT_MESSAGES,
  messages,
});

export const setLoadingMessages = (isLoadingMessages) => ({
  type: SET_LOADING_MESSAGES,
  isLoadingMessages,
});

// Initial State
const initialState = {
  chatbotfiles: {},
  messages: [{ type: "bot", content: "Hi! What would you like to get done today?" }],
  isLoadingMessages: false,
};

// Reducer
export default createReducer(initialState, {
  [SET_CHATBOT_FILES]: (state, { chatbotfiles }) => ({
    ...state,
    chatbotfiles,
  }),
  [SET_CHAT_MESSAGES]: (state, { messages }) => ({
    ...state,
    messages: Array.isArray(messages) ? messages : state.messages,
  }),
  [SET_LOADING_MESSAGES]: (state, { isLoadingMessages }) => ({
    ...state,
    isLoadingMessages,
  }),
  [CLEAR_CHAT_MESSAGES]: (state) => ({
    ...state,
    messages: [{ type: "bot", content: "Hi! What would you like to get done today?" }],
  }),
});
